import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { apiClient } from '../../components/api/ApiClient';
import { useNavigate } from 'react-router-dom';

const CATEGORIES = [
    { value: 'technical', label: 'واحد فنی' },
    { value: 'sale', label: 'واحد فروش' },
];

const PRIORITIES = [
    { value: 'low', label: 'کم' },
    { value: 'medium', label: 'متوسط' },
    { value: 'high', label: 'زیاد' },
];

function TicketCreate() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        title: '',
        category: 'technical',
        priority: 'medium',
        message: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleCreate = async () => {
        try {
            await apiClient('/internal-network/api/ticket/', {
                method: 'POST',
                data: formData
            });
            navigate('/ticket/list/');
        } catch (error) {
            console.error("Error creating ticket:", error);
            alert('خطا در ایجاد تیکت');
        }
    };

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card stretch stretch-full">
                    <div className="card-header">
                        <h5 className="card-title">ایجاد تیکت جدید</h5>
                    </div>
                    <div className="card-body">
                        <Form>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label>دپارتمان</Form.Label>
                                        <Form.Select name="category" value={formData.category} onChange={handleInputChange}>
                                            {CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label>اهمیت</Form.Label>
                                        <Form.Select name="priority" value={formData.priority} onChange={handleInputChange}>
                                            {PRIORITIES.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                            </div>
                            <div className="mb-3">
                                <Form.Group>
                                    <Form.Label>موضوع</Form.Label>
                                    <Form.Control type="text" name="title" value={formData.title} onChange={handleInputChange} />
                                </Form.Group>
                            </div>
                            <div className="mb-3">
                                <Form.Group>
                                    <Form.Label>متن پیام</Form.Label>
                                    <Form.Control as="textarea" rows={5} name="message" value={formData.message} onChange={handleInputChange} />
                                </Form.Group>
                            </div>
                        </Form>
                    </div>
                    <div className="card-footer text-end">
                        <Button variant="danger" className="me-2" onClick={() => navigate('/ticket/list/')}>لغو</Button>
                        <Button variant="success" onClick={handleCreate}>ارسال تیکت</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TicketCreate;
